// In-memory only: clinical drafts never enter browser storage or network logs.
const drafts = new Map();
const MAX_AGE = 30 * 60 * 1000;
export const draftKey = (user, encounterId) => user?.user_id && user?.clinic_id
  ? `${user.user_id}:${user.clinic_id}:${encounterId}` : null;
export function rememberDraft(key, value) {
  if (!key) return;
  drafts.delete(key);
  drafts.set(key, { value, at: Date.now() });
  while (drafts.size > 5) drafts.delete(drafts.keys().next().value);
}
export function readDraft(key) {
  const entry = drafts.get(key);
  if (!entry) return null;
  if (Date.now() - entry.at > MAX_AGE) { drafts.delete(key); return null; }
  return entry.value;
}
export function forgetDraft(key) { drafts.delete(key); }
